<!-- Barre de progression en haut de la page -->
<div class="loading-progress-bar" *ngIf="isLoading">
  <div class="progress-bar-fill" [style.width.%]="loadingProgress"></div>
</div>


<router-outlet></router-outlet>
<router-outlet name="asset"></router-outlet>
